<template>
  <div
    v-if="data"
    :id="data.id"
    class="bg-gray-lighten3 pt-11 pt-14 text-slate"
  >
    <div class="container flex flex-col gap-y-8 sm:text-center md:gap-y-12">
      <div
        v-if="data.image"
        v-lazy-background="getAssetUrl(data.image)"
        class="relative aspect-[327/244] rounded-lg bg-cover bg-center sm:order-last sm:aspect-auto sm:h-[400px] lg:min-h-[640px] 3xl:min-h-[868px]"
      >
        <ProductContentBannerPoints
          v-if="data.points"
          :items="data.points"
          class="hidden sm:flex"
        />
      </div>

      <div>
        <h2
          v-if="data.title"
          class="title text-3xl uppercase leading-none sm:whitespace-pre-line md:text-6xl"
          v-html="data.title"
        />

        <p
          v-if="data.text"
          class="mt-6 text-md leading-[1.8rem] sm:whitespace-pre-line"
          v-html="data.text"
        />

        <ProductContentBannerPoints
          v-if="data.points"
          :items="data.points"
          class="flex sm:hidden"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useMediaAsset } from '~/composables';
import ProductContentBannerPoints from '~/components/sections/productSection/ProductContentBannerPoints.vue';

interface Props {
  data?: any;
}

withDefaults(defineProps<Props>(), {
  data: () => ({}),
});

const { getAssetUrl } = useMediaAsset();
</script>

<style lang="sass" scoped>
.point
    background: linear-gradient(180deg, rgba(126, 126, 126, 0.24) 0%, rgba(187, 187, 187, 0.16) 100%)
</style>
